module.exports = __webpack_public_path__ + "img/zhibo.5c7dba02.png";